import { NgModule } from '@angular/core'
import { PRECONNECT_CHECK_BLOCKLIST } from '@angular/common'
import { AppComponent } from './app.component'
import { AppRoutingModule } from './app-routing.module'
import { RouterLink } from '@angular/router'
import { Title } from '@angular/platform-browser'
import { SharedModule } from './shared/shared.module'
import { DashboardComponent } from './dashboard/protected/dashboard.component'
import { CoreModule } from './core/core.module'
import { HomeComponent } from './landingpage/home/home.component'
import { LoginComponent } from './landingpage/login/login.component'
import { REALTIME_EVENT_GATEWAY_PROVIDERS } from 'core-client/api'


@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    AppRoutingModule,
    RouterLink,
    CoreModule.forRoot(),
    SharedModule,
    HomeComponent,
    LoginComponent,
    DashboardComponent
  ],
  providers: [
    Title,
    { provide: PRECONNECT_CHECK_BLOCKLIST, useFactory: () => [location.origin] },
    ...REALTIME_EVENT_GATEWAY_PROVIDERS,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
